import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import contactsList from '../page/List.vue'
import contactsMenu from '../page/List_menu.vue'
import contactEdit from '../page/Edit.vue'
import Mailing from '../page/Mailing.vue'
import MailingSending from '../page/MailingSending.vue'
import MailingMessages from '../page/MailingMessages.vue'
import MailingOptions from '../page/MailingOptions.vue'
import MailingMenu from '../page/Mailing_menu.vue'
import Config from '../page/Config.vue'
import Config_menu from '../page/Config_menu.vue'
import ConfigAccounts from '../page/ConfigAccounts.vue'
import ConfigAttributes from '../page/ConfigAttributes.vue'

Vue.use(Router)

var mode = 'hash'
// var mode = 'history'

// if (!Quasar.Platform.is.cordova) {
//   mode = 'history'
// }

var pathname = window.location.pathname

const router = new Router({
  mode: mode,
  base: window.location.pathname,
  routes: [
    {
      path: '/gestion/:type',
      components: {
        default: contactsList,
        menu: contactsMenu
      }
    },
    {
      path: '/gestion/:type/new',
      components: {
        default: contactEdit,
        menu: contactsMenu
      }
    },
    {
      path: '/gestion/:type/edit/:contact_id',
      components: {
        default: contactEdit,
        menu: contactsMenu
      }
    },
    {
      path: '/mailing',
      components: {
        default: Mailing,
        menu: MailingMenu
      },
      children: [
        {
          path: 'messages',
          name: 'mailing_messages',
          component: MailingMessages
        },
        {
          path: 'templates',
          name: 'mailing_templates',
          component: MailingMessages
        },
        {
          path: 'envois',
          name: 'mailing_envois',
          component: MailingSending
        },
        {
          path: 'options',
          name: 'mailing_options',
          component: MailingOptions
        },
      ]
    },
    {
      path: '/config',
      components: {
        default: Config,
        menu: Config_menu
      },
      children: [
        {
          path: 'comptes',
          component: ConfigAccounts
        },
        {
          path: 'attributs',
          component: ConfigAttributes
        }
      ]
    },
    {
      path: '/login',
      components: {
        default: contactsList
      }
    },
    {
      path: '*',
      redirect: '/gestion/contact'
    }
  ]
})

export default router
